import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

const VideoContainer = styled.div`
  width: 100%;
  max-width: 100%;
  
  .video-js {
    width: 100% !important;
    height: 400px !important;
    border-radius: 6px;
    overflow: hidden;
  }
  
  @media (max-width: 768px) {
    .video-js {
      height: 250px !important;
    }
  }
`;

const StatusBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 16px;
`;

const StatusInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: #4a5568;
`;

const LiveIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  background: ${props => props.isLive ? '#fed7d7' : '#e2e8f0'};
  color: ${props => props.isLive ? '#c53030' : '#718096'};
  
  i {
    font-size: 0.625rem;
  }
`;

const VideoPlayer = () => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    if (videoRef.current && !playerRef.current) {
      const player = videojs(videoRef.current, {
        controls: true,
        autoplay: true,
        muted: false,
        liveui: true,
        responsive: true,
        fluid: true,
        errorDisplay: false,
        html5: {
          hls: {
            enableLowInitialPlaylist: true,
            smoothQualityChange: true,
            backBufferLength: 30,
            maxBufferLength: 30,
            maxMaxBufferLength: 60,
            liveSyncDurationCount: 3,
            liveMaxLatencyDurationCount: 5
          }
        },
        liveTracker: {
          trackingThreshold: 0,
          liveTolerance: 5
        },
        playbackRates: [0.5, 1, 1.25, 1.5],
        userActions: {
          hotkeys: true
        }
      });

      playerRef.current = player;

      player.on('error', () => {
        console.log('Player error:', player.error());
        setIsLive(false);
      });

      player.on('playing', () => {
        console.log('Stream is playing');
        setIsLive(true);
      });

      player.on('waiting', () => {
        console.log('Video is waiting for data');
      });

      checkStreamStatus();
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, []);

  const checkStreamStatus = async () => {
    try {
      const response = await fetch('http://159.198.65.99:3000/api/status', {
        headers: {
          'Authorization': 'Bearer holytv_api_key_2024_secure_streaming_server'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.activeStreams > 0) {
          const url = `http://159.198.65.99:8000/live/holy_tv_livestream_key/index.m3u8`;
          loadStream(url);
        } else {
          setIsLive(false);
        }
      }
    } catch (error) {
      console.error('Error checking stream status:', error);
      setIsLive(false);
    }
  };

  const loadStream = (url) => {
    if (playerRef.current) {
      playerRef.current.src({
        src: url,
        type: 'application/x-mpegURL'
      });
    }
  };

  return (
    <div>
      <StatusBar>
        <StatusInfo>
          <i className="fas fa-video"></i>
          <span>Live Stream Player</span>
        </StatusInfo>
        <LiveIndicator isLive={isLive}>
          <i className="fas fa-circle"></i>
          <span>{isLive ? 'LIVE' : 'OFFLINE'}</span>
        </LiveIndicator>
      </StatusBar>
      
      <VideoContainer>
        <video
          ref={videoRef}
          className="video-js vjs-default-skin vjs-big-play-centered"
          controls
          preload="auto"
          data-setup="{}"
        >
          <p className="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a
            web browser that supports HTML5 video.
          </p>
        </video>
      </VideoContainer>
    </div>
  );
};

export default VideoPlayer; 